import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing-three',
  templateUrl: './pricing-three.component.html',
  styleUrls: ['./pricing-three.component.css']
})
export class PricingThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
